import { STATUS } from '@voladeum/client';
import { CHIP_VARIANT } from 'framework/chip/enums';

export const getPairStatusVariant = (status_id: number): CHIP_VARIANT => {
  switch (status_id) {
    case STATUS.INITIALIZED:
    case STATUS.ARCHIVED:
      return CHIP_VARIANT.LIVID;
    case STATUS.RETRYING:
    case STATUS.PAUSED:
      return CHIP_VARIANT.ORANGE;
    case STATUS.RUNNING:
    case STATUS.QUEUED:
      return CHIP_VARIANT.BLUE;
    case STATUS.FAILED:
      return CHIP_VARIANT.RED;
    case STATUS.ACTIVE:
    case STATUS.SUCCESS:
    case STATUS.COMPLETED:
    case STATUS.COMPLETED_PARTIAL:
      return CHIP_VARIANT.GREEN;
  }
  return CHIP_VARIANT.DARK;
};
